import React, { Component } from "react";
import OrderTitleForm
 from "./OrderTitleForm";
class OrderTitlePage extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount(){
    console.log('loadtitle')
    }
    render() {
        return (
            <OrderTitleForm OrderProductId={this.props.OrderProductId}/>
        )
    }
}

export default OrderTitlePage